import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onFileValidationData", "openInvoiceEditor", "canEditInvoice", "children", "invoiceValidation", "source"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { invoiceOnFileChargeValidationMessageSubCategories } from '../../api/validationsAPI';
import ChargePaymentMethodTooltipMessage from './ChargePaymentMethodTooltipMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export const CHARGE_PAYMENT_METHOD_SOURCE = {
  SIDEBAR: 'SIDEBAR',
  EDITOR: 'EDITOR'
};
function ChargePaymentMethodTooltip(_ref) {
  let {
      onFileValidationData,
      openInvoiceEditor,
      canEditInvoice = false,
      children,
      invoiceValidation,
      source
    } = _ref,
    tooltipProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const disabledReason = onFileValidationData === null || onFileValidationData === void 0 ? void 0 : onFileValidationData.subCategory;
  const disabled = Boolean(disabledReason || invoiceValidation);
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !disabled,
    headingText: disabledReason === invoiceOnFileChargeValidationMessageSubCategories.PMOF_IS_NOT_CHARGEABLE && /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.popover.title"
    }),
    title: /*#__PURE__*/_jsx(ChargePaymentMethodTooltipMessage, {
      invoiceValidation: invoiceValidation,
      onClick: canEditInvoice ? openInvoiceEditor : undefined,
      onFileValidation: onFileValidationData,
      source: source
    }),
    use: disabledReason === invoiceOnFileChargeValidationMessageSubCategories.PMOF_IS_NOT_CHARGEABLE ? 'longform' : 'default',
    placement: tooltipProps.placement || 'left',
    children: children
  });
}
export default ChargePaymentMethodTooltip;